/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AuthLoginByApprovedLoginRequestRequestDto } from '../models/auth-login-by-approved-login-request-request-dto';
import { AuthLoginByDescopeTokenRequestDto } from '../models/auth-login-by-descope-token-request-dto';
import { AuthLoginByDescopeTokenWithoutDeviceRequestDto } from '../models/auth-login-by-descope-token-without-device-request-dto';
import { AuthLoginWithEmailRequestDto } from '../models/auth-login-with-email-request-dto';
import { AuthLoginWithPhoneNumberRequestDto } from '../models/auth-login-with-phone-number-request-dto';
import { AuthLoginWithUsernameRequestDto } from '../models/auth-login-with-username-request-dto';
import { AuthRegisterRequestDto } from '../models/auth-register-request-dto';
import { LoginRequestDto } from '../models/login-request-dto';
import { User } from '../models/user';
import { UserWithRelations } from '../models/user-with-relations';

@Injectable({
  providedIn: 'root',
})
export class AuthControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation authControllerLogin
   */
  static readonly AuthControllerLoginPath = '/auth/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `login()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login$Response(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: LoginRequestDto
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginPath, 'post');
    if (params) {
      rb.header('x-public-key', params['x-public-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `login$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: LoginRequestDto
  }): Observable<User> {

    return this.login$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation authControllerLoginByApprovedLoginRequest
   */
  static readonly AuthControllerLoginByApprovedLoginRequestPath = '/auth/login-by-approved-login-request/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginByApprovedLoginRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginByApprovedLoginRequest$Response(params: {
    id: string;
    body?: AuthLoginByApprovedLoginRequestRequestDto
  }): Observable<StrictHttpResponse<UserWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginByApprovedLoginRequestPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginByApprovedLoginRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginByApprovedLoginRequest(params: {
    id: string;
    body?: AuthLoginByApprovedLoginRequestRequestDto
  }): Observable<User> {

    return this.loginByApprovedLoginRequest$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation authControllerLoginByAuthorizationToken
   */
  static readonly AuthControllerLoginByAuthorizationTokenPath = '/auth/login-by-authorization-token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginByAuthorizationToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  loginByAuthorizationToken$Response(params?: {
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginByAuthorizationTokenPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginByAuthorizationToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loginByAuthorizationToken(params?: {
  }): Observable<User> {

    return this.loginByAuthorizationToken$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation authControllerLoginByDescopeToken
   */
  static readonly AuthControllerLoginByDescopeTokenPath = '/auth/login-by-descope-token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginByDescopeToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginByDescopeToken$Response(params?: {
    body?: AuthLoginByDescopeTokenRequestDto
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginByDescopeTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginByDescopeToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginByDescopeToken(params?: {
    body?: AuthLoginByDescopeTokenRequestDto
  }): Observable<User> {

    return this.loginByDescopeToken$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation authControllerLoginByDescopeTokenWithoutDevice
   */
  static readonly AuthControllerLoginByDescopeTokenWithoutDevicePath = '/auth/login-by-descope-token-without-device';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginByDescopeTokenWithoutDevice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginByDescopeTokenWithoutDevice$Response(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: AuthLoginByDescopeTokenWithoutDeviceRequestDto
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginByDescopeTokenWithoutDevicePath, 'post');
    if (params) {
      rb.header('x-public-key', params['x-public-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginByDescopeTokenWithoutDevice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginByDescopeTokenWithoutDevice(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: AuthLoginByDescopeTokenWithoutDeviceRequestDto
  }): Observable<User> {

    return this.loginByDescopeTokenWithoutDevice$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation authControllerLoginWithEmail
   */
  static readonly AuthControllerLoginWithEmailPath = '/auth/login-with-email';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginWithEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginWithEmail$Response(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: AuthLoginWithEmailRequestDto
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginWithEmailPath, 'post');
    if (params) {
      rb.header('x-public-key', params['x-public-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginWithEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginWithEmail(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: AuthLoginWithEmailRequestDto
  }): Observable<User> {

    return this.loginWithEmail$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation authControllerLoginWithPhoneNumber
   */
  static readonly AuthControllerLoginWithPhoneNumberPath = '/auth/login-with-phone-number';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginWithPhoneNumber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginWithPhoneNumber$Response(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: AuthLoginWithPhoneNumberRequestDto
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginWithPhoneNumberPath, 'post');
    if (params) {
      rb.header('x-public-key', params['x-public-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginWithPhoneNumber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginWithPhoneNumber(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: AuthLoginWithPhoneNumberRequestDto
  }): Observable<User> {

    return this.loginWithPhoneNumber$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation authControllerLoginWithUsername
   */
  static readonly AuthControllerLoginWithUsernamePath = '/auth/login-with-username';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginWithUsername()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginWithUsername$Response(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: AuthLoginWithUsernameRequestDto
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginWithUsernamePath, 'post');
    if (params) {
      rb.header('x-public-key', params['x-public-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginWithUsername$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginWithUsername(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: AuthLoginWithUsernameRequestDto
  }): Observable<User> {

    return this.loginWithUsername$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation authControllerRegister
   */
  static readonly AuthControllerRegisterPath = '/auth/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `register()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  register$Response(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: AuthRegisterRequestDto
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerRegisterPath, 'post');
    if (params) {
      rb.header('x-public-key', params['x-public-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `register$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  register(params: {

    /**
     * public key must be encoded as uri
     */
    'x-public-key': string;
    body?: AuthRegisterRequestDto
  }): Observable<User> {

    return this.register$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

}
